import { Record, Map } from 'immutable';
import { fetchTouchpointActions, submitTouchpointActions, fetchAttachmentActions, fetchTouchpointResponseActions, fetchTouchpointResponsesActions } from './touchpoints.actions';
import { responsesActions } from '../responses';
import * as api from '../api';

export const TouchpointState = Record({
  err: null,
  isFetching: false,
  touchpointResponseEntry: Map({}),
  zipAutofill: Map({}),
  touchpointForms: Map({}),
  formSubmission: Map({}),
  attachments: Map({}),
  touchpointResponses: Map({}),
  /** paged list of form responses, for view all responses page and recent responses */
  pagedFormResponses: Map({}),
});

export const ZipAutofillState = Record({
  err: null,
  isFetching: false
});

export const touchpointsReducer = (initialState = new TouchpointState(), action) => {
  const guidEmpty = '00000000-0000-0000-0000-000000000000';  // used as a default for fetching touchpoint responses.

  var state = initialState;
  if(!!action.id) {
    state = state.setIn(['touchpointForms', action.id],
      api.apiCallReducer(state.getIn(['touchpointForms', action.id]), action, fetchTouchpointActions));

    state = state.setIn(['formSubmission', action.id],
      api.apiCallReducer(state.getIn(['formSubmission', action.id]), action, submitTouchpointActions));

    state = state.setIn(['attachments', action.id],
      api.apiCallReducer(state.getIn(['attachments', action.id]), action, fetchAttachmentActions));

    state = state.setIn(['touchpointResponses', action.id],
      api.apiCallReducer(state.getIn(['touchpointResponses', action.id]), action, fetchTouchpointResponseActions));

    state = state.setIn(['pagedFormResponses', action.id],
      api.apiCallReducer(state.getIn(['pagedFormResponses', action.id]), action, fetchTouchpointResponsesActions));
  }

  switch (action.type) {
    case responsesActions.pagingActions.page:
    case responsesActions.pagingActions.perPage:
    case responsesActions.pagingActions.sort:
    case responsesActions.actionTypes.APPLY_FILTER:
      return state.setIn(['pagedFormResponses',  guidEmpty, 'isValid'], false);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/touchpoints/touchpoints.reducer.js